import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@chargify/custom-ui-components';

import { Wrapper } from './ShowMore.styles';

export type ShowMoreProps = {
  /**
   * Identificator of expanded state
   */
  isExpanded: boolean;
  /**
   * Number of items;
   */
  items: number;
  /**
   * Click event handler
   */
  onClick: () => void;
};

const ShowMore = ({ isExpanded, items, onClick }: ShowMoreProps) => {
  const { t } = useTranslation();

  return (
    <Wrapper paddingTop={24} paddingBottom={32}>
      <Button
        label={t(isExpanded ? 'show_less' : 'show_more', {
          ns: 'subscriptions-manager',
          numberOfItems: items,
        })}
        color="secondary"
        onClick={onClick}
      />
    </Wrapper>
  );
};

export default ShowMore;
